import {RaEvent, RaEventType} from "./RaEvent";

export class StartQuizEvent extends RaEvent {
    static TYPE:RaEventType = "start_quiz_event";
    constructor() {
        super(StartQuizEvent.TYPE);
    }
}

export class StopQuizEvent extends RaEvent {
    static TYPE: RaEventType = "stop_quiz_event";
    constructor() {
        super(StopQuizEvent.TYPE);
    }
}
